import { motion } from "framer-motion";
import { MANIFESTO } from "@/lib/site";
import { fadeUp } from "@/lib/anim";

export const Manifesto = () => {
  return (
    <section id="approach" data-testid="manifesto-section" className="border-b border-line bg-ink-800">
      <div className="mx-auto max-w-[1600px] px-5 md:px-10 py-20 md:py-28">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10">
          <div className="lg:col-span-4">
            <div className="lg:sticky lg:top-28">
              <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-acid mb-5">/ 02 — Approach</p>
              <h2 className="font-display font-black tracking-tighter leading-[0.9] text-5xl md:text-6xl">
                THE<br />INSIGHT<br />METHOD
              </h2>
            </div>
          </div>

          <div className="lg:col-span-8">
            {MANIFESTO.map((m, i) => (
              <motion.div
                key={m.no}
                data-testid={`manifesto-${m.no}`}
                variants={fadeUp}
                custom={i}
                initial="hidden"
                whileInView="show"
                viewport={{ once: true, margin: "-80px" }}
                className="grid grid-cols-12 gap-4 md:gap-8 border-t border-line py-10 md:py-14 first:border-t-0"
              >
                <div className="col-span-12 md:col-span-2">
                  <span className="outline-text font-display font-black text-6xl md:text-7xl">{m.no}</span>
                </div>
                <div className="col-span-12 md:col-span-10">
                  <h3 className="font-display font-bold tracking-tight text-2xl md:text-4xl leading-[1.05] max-w-2xl">
                    {m.head}
                  </h3>
                  <p className="mt-4 text-white/55 max-w-xl leading-relaxed">{m.body}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
